// extracted by mini-css-extract-plugin
export default {"advertDetailHeaderPrice":"c-l_hm","advertDetailHeaderPrice__value":"c-l_hn","advertDetailHeaderPrice__label":"c-l_ho"};